import { render } from "./MyProjectComponent2.vue?vue&type=template&id=f560775a&scoped=true"
import script from "./MyProjectComponent2.vue?vue&type=script&lang=js"
export * from "./MyProjectComponent2.vue?vue&type=script&lang=js"

import "./MyProjectComponent2.vue?vue&type=style&index=0&id=f560775a&scoped=true&lang=css"

import exportComponent from "D:\\Work\\Contractly\\Contractly.Site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f560775a"]])

export default __exports__